import axios from "axios";
import { deviceModelLookupSlice } from "../../slice/chargingDevice/getDeviceModelLookupSlice";
import apiHeader from "../../../Components/ApiHeader";

const { actions } = deviceModelLookupSlice;

export const deviceModelLookUpDropdownAPI: any =
  ({ ApiUrl, Type, params }: any) =>
  (dispatch: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    axios
      .get(ApiUrl, {
        params: params,
        headers: commonHead,
      })
      .then((response) => {
        const { data } = response;
        dispatch(actions.getDeviceModelData({ type: Type, data }));
      })
      .catch((err) => {
        dispatch(
          actions.getDeviceModelData({
            type: "error",
            paylod: err.message,
          })
        );
      });
  };
